import { PathfinderWrapperType } from '@fiverr-private/gig_page_context';
import { getSellerUrl } from './getSellerUrl';

interface GetProfileUrlParams {
    pathfinderWrapper: PathfinderWrapperType;
    isAgency: boolean;
    agency?: { slug?: string | null };
}

export const getProfileUrl = ({ pathfinderWrapper, isAgency, agency }: GetProfileUrlParams): string => {
    if (isAgency && agency?.slug) {
        return pathfinderWrapper.pathfinder('agency_page', { agency_slug: agency.slug });
    }
    return getSellerUrl({ pathfinderWrapper });
};
